import axios from 'axios';
import { getBaseUrlAnalista, ensureProtocol } from '../config/backend';
import { refreshAccessToken, iniciarGestaoToken } from '../App/tokenManager';

async function VerificarApp() {
    const baseUrl = getBaseUrlAnalista() || ensureProtocol(localStorage.getItem('ipBackend2') || '');
    if (!baseUrl) {
        console.warn('VerificarToken: Backend Analista não configurado. Defina REACT_APP_BACKEND_ANALISTA no .env e reinicie o servidor (npm start).');
        return;
    }

    const token = localStorage.getItem('token');
    if (!token || token.trim() === '') {
        return;
    }

    try {
        await axios.get(baseUrl + '/token', {
            headers: { Authorization: token },
        });
    } catch (error) {
        const status = error?.response?.status;
        if (status === 401 || status === 403) {
            await refreshAccessToken();
        }
    } finally {
        iniciarGestaoToken();
    }
}

export default VerificarApp;
